import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import { useState } from "react";
import { CustomInputField } from "../custom-input-field";

export const PasswordField = (props) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const handleTogglePasswordClick = () => setIsPasswordShown(!isPasswordShown);

  return (
    <CustomInputField
      {...props}
      InputProps={{
        type: isPasswordShown ? "text" : "password",
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleTogglePasswordClick} edge="end">
              {isPasswordShown ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
